export default __webpack_public_path__ + "static/ListenonYouTubeMusic-black-SVG-1d2226909ab5b2c249acd0163d191aa8.svg";